import { ContentImage } from './ContentImage';

export type { TypeContentImageProps } from './types';
export default ContentImage;
